module.exports = __webpack_public_path__ + "img/info-02.45d555c9.jpg";